function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "dedicated_svg__a",
  x: 0,
  y: 22.322,
  width: 63.377,
  height: 44.785,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "b"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodColor: "#ff6c6c",
  floodOpacity: 0.745
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "b"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("style", null, ".dedicated_svg__b,.dedicated_svg__e,.dedicated_svg__i,.dedicated_svg__m{fill:none}.dedicated_svg__b,.dedicated_svg__c{stroke:#383d5a}.dedicated_svg__b,.dedicated_svg__c,.dedicated_svg__e,.dedicated_svg__f,.dedicated_svg__i,.dedicated_svg__j{stroke-linecap:round;stroke-width:2px}.dedicated_svg__b,.dedicated_svg__i{stroke-linejoin:round}.dedicated_svg__c{fill:#383d5a}.dedicated_svg__e,.dedicated_svg__f{stroke:#1b1c26}.dedicated_svg__f,.dedicated_svg__j{fill:#1c272c}.dedicated_svg__g{fill:#1b1c26}.dedicated_svg__i,.dedicated_svg__j{stroke:#ff6c6c}.dedicated_svg__l{stroke:none}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "dedicated_svg__b",
  d: "M34.118 20.996h15.578a2.6 2.6 0 002.595-2.6v-13.5"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "dedicated_svg__c",
  transform: "translate(50.733 3.152)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "dedicated_svg__l",
  width: 3.117,
  height: 3.117,
  rx: 1.558
}), /*#__PURE__*/React.createElement("rect", {
  className: "dedicated_svg__m",
  x: -1,
  y: -1,
  width: 5.117,
  height: 5.117,
  rx: 2.558
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "dedicated_svg__b",
  d: "M27.105 15.878h15.578a2.6 2.6 0 002.595-2.595V9.13"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  className: "dedicated_svg__c",
  transform: "translate(43.72 5.048)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "dedicated_svg__l",
  width: 3.117,
  height: 3.117,
  rx: 1.558
}), /*#__PURE__*/React.createElement("rect", {
  className: "dedicated_svg__m",
  x: -1,
  y: -1,
  width: 5.117,
  height: 5.117,
  rx: 2.558
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.961 2.234)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 29.61,
  height: 42.078,
  rx: 6,
  fill: "#383d5a"
}), /*#__PURE__*/React.createElement("path", {
  className: "dedicated_svg__e",
  d: "M-1.787 10.909h32.244M-1.787 22.818h32.244"
}), /*#__PURE__*/React.createElement("path", {
  className: "dedicated_svg__f",
  d: "M19.481 2.896v3.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "dedicated_svg__e",
  d: "M9.351 14.805v3.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "dedicated_svg__f",
  d: "M23.377 2.896v3.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "dedicated_svg__e",
  d: "M5.455 14.805v3.9"
}), /*#__PURE__*/React.createElement("circle", {
  className: "dedicated_svg__g",
  cx: 2.727,
  cy: 2.727,
  r: 2.727,
  transform: "translate(4.675 2.117)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "dedicated_svg__g",
  cx: 2.727,
  cy: 2.727,
  r: 2.727,
  transform: "translate(4.675 25.156)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "dedicated_svg__g",
  cx: 2.727,
  cy: 2.727,
  r: 2.727,
  transform: "translate(18.701 14.026)"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  fill: "#ff6c6c"
}, /*#__PURE__*/React.createElement("path", {
  className: "dedicated_svg__l",
  d: "M48.682 59.107H17.928C12.453 59.107 8 54.652 8 49.176c0-5.473 4.453-9.924 9.928-9.924.918 0 1.816.123 2.685.367a13.754 13.754 0 014.475-6.356 13.61 13.61 0 013.904-2.162 13.626 13.626 0 014.559-.779c6.91 0 12.676 5.156 13.537 11.91 4.584.078 8.289 3.832 8.289 8.436a8.41 8.41 0 01-2.2 5.68 8.422 8.422 0 01-4.495 2.578v.181z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.682 58.107v-.037a7.441 7.441 0 006.695-7.402 7.435 7.435 0 00-7.437-7.438c-.256 0-.512.012-.762.035-.37-6.66-5.883-11.943-12.627-11.943-5.926 0-10.899 4.074-12.272 9.58a8.886 8.886 0 00-3.351-.65C12.998 40.252 9 44.25 9 49.176c0 4.93 3.998 8.931 8.928 8.931h29.754m2 2H17.928C11.902 60.107 7 55.203 7 49.176c0-6.024 4.902-10.924 10.928-10.924.697 0 1.385.064 2.058.193a14.732 14.732 0 014.48-5.965 14.589 14.589 0 019.084-3.158c7.134 0 13.132 5.121 14.401 11.961a9.372 9.372 0 015.662 2.709 9.386 9.386 0 012.764 6.676 9.41 9.41 0 01-2.459 6.353 9.435 9.435 0 01-4.236 2.68v.406z",
  fill: "#1b1c26"
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "dedicated_svg__i",
  d: "M52.07 47.565v-13.5"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  className: "dedicated_svg__j",
  transform: "translate(50.512 32.321)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "dedicated_svg__l",
  width: 3.117,
  height: 3.117,
  rx: 1.558
}), /*#__PURE__*/React.createElement("rect", {
  className: "dedicated_svg__m",
  x: -1,
  y: -1,
  width: 5.117,
  height: 5.117,
  rx: 2.558
}));

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "dedicated_svg__i",
  d: "M45.057 42.11v-13.5"
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  className: "dedicated_svg__j",
  transform: "translate(43.499 26.866)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "dedicated_svg__l",
  width: 3.117,
  height: 3.117,
  rx: 1.558
}), /*#__PURE__*/React.createElement("rect", {
  className: "dedicated_svg__m",
  x: -1,
  y: -1,
  width: 5.117,
  height: 5.117,
  rx: 2.558
}));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .002)",
  filter: "url(#dedicated_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.924 58.103a8.928 8.928 0 113.352-17.205 12.648 12.648 0 0124.9 2.363c.25-.023.506-.035.762-.035a7.439 7.439 0 01.742 14.84v.037z",
  fill: "#ff6c6c"
}));

var SvgDedicated = function SvgDedicated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63.377,
    height: 67.107
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

export default "data:image/svg+xml;base64,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";
export { SvgDedicated as ReactComponent };